import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./actionBubble.module.css";

interface ActionBubbleProps {
    text?: string;
    onClick: () => void;
    className?: string;
    icon?: React.ReactNode;
    /**
     * Controls where the bubble is visible.
     * If provided, the bubble will render only when the current pathname matches one of the patterns.
     * Patterns ending with '*' are treated as prefix matches (e.g., "/admin/*").
     * Default: ["/"] (home page only)
     */
    showOnRoutes?: string[];
}

const ActionBubble: React.FC<ActionBubbleProps> = ({ text = "Ota yhteyttä tästä!", onClick, className = "", icon = null, showOnRoutes = ["/"] }) => {
    const { pathname } = useLocation();

    // Hide on any admin routes
    if (pathname.includes("/admin")) {
        return null;
    }

    const matches = (pattern: string) => {
        if (!pattern) return false;
        if (pattern.endsWith("*")) {
            const base = pattern.slice(0, -1);
            return pathname.startsWith(base);
        }
        return pathname === pattern;
    };

    const shouldRender = Array.isArray(showOnRoutes) && showOnRoutes.length > 0 ? showOnRoutes.some(matches) : false;

    if (!shouldRender) return null;

    return (
        <div
            className={`${styles.actionBubble} ${className}`}
            onClick={onClick}
            role="button"
            tabIndex={0} // keeps it keyboard focusable
        >
            {icon && <span className={styles.actionBubbleIcon}>{icon}</span>}
            <span className={styles.actionBubbleText}>{text}</span>
        </div>
    );
};

export default ActionBubble;
